import { render } from "./icon-gr-search.svg?vue&type=template&id=9a52921e?inline"
const script = {}
script.render = render

export default script